// extracted by mini-css-extract-plugin
module.exports = {"responsive-imagex1":"_17uPO","responsive-imagex2":"NuUU0","picture":"aReKb","image":"_2mEVw"};